

const requestTypeCodesString = {
  Estudiantes: "Estudiante",
  Grupo: "Grupo",
  DosMasEstudiantes: "Dos o más estudiantes",
};
const requestTypeCodes = {
  Estudiantes: 446,
  Grupo: 447,
  DosMasEstudiantes: 448,
};

export  {requestTypeCodes, requestTypeCodesString};
